import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/settings/anonymous_events')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/workspaces/$workspaceId/settings/merge_options',
      params: { workspaceId: params.workspaceId },
      replace: true,
    });
  },
});
